{
  "footer-powered-by": "Réalisé par ",
  "footer-extra": ", une entreprise de Boise ID"
}
